import React from 'react';
import './common.scss';

const NavigationDots = ({ active }) => (
  <div className="app__navigation">
    {['home', 'about', 'work', 'skills', 'testimonials', 'contact'].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className="app__navigation-dot"
        style={active === item ? { backgroundColor: '#08a4a7' } : {backgroundColor: '#85f1de'}}
      />
    ))}
  </div>
);

export default NavigationDots;